export default function OperationalGaps() {
  const gaps = [
    {
      icon: 'ri-alert-line',
      title: 'Misaligned Component Positioning',
      description: 'Critical components are not positioned based on downtime risk'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'Visibility Breaks',
      description: 'Visibility breaks across supplier → storage → site handoffs'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Reactive Expediting',
      description: 'Expedited shipments become reactive and costly'
    },
    {
      icon: 'ri-question-line',
      title: 'Unclear Ownership',
      description: 'Ownership during delays is unclear'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <div className="w-2 h-2 bg-[#0A5F5C] rounded-full"></div>
            <span className="text-[#0A5F5C] font-semibold text-sm uppercase tracking-wider">The Challenge</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2332] mb-6">
            Operational Gaps That Create Avoidable Risk
          </h2>
          <p className="text-lg text-[#5A6670] max-w-3xl mx-auto">
            Even in high-availability environments, coordination gaps create exposure
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {gaps.map((gap, index) => (
            <div
              key={index}
              className="bg-[#F5F5F7] rounded-2xl p-8 hover:-translate-y-2 transition-all duration-300 hover:shadow-xl"
            >
              <div className="w-16 h-16 bg-[#E67E50]/10 rounded-full flex items-center justify-center mb-6">
                <i className={`${gap.icon} text-3xl text-[#E67E50]`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1A2332] mb-3">
                {gap.title}
              </h3>
              <p className="text-[#5A6670] leading-relaxed">
                {gap.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-lg text-[#5A6670] font-medium">
            These gaps increase response variability, escalation cycles, and operational uncertainty.
          </p>
        </div>
      </div>
    </section>
  );
}
